import { Injectable } from '@angular/core';
import { ConfigService } from '../shared/services/config/config.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class UltiProAuthService {

  constructor(private configService: ConfigService,
              private oAuthService: OAuthService) {
  }

  private sessionStorageKey = 'ultipro_access_token';

  authorize(token: string) {
    if (sessionStorage.getItem(this.sessionStorageKey)) {
      sessionStorage.removeItem(this.sessionStorageKey);
    }

    if (token && this.configService.authenticationEnabled) {
      sessionStorage.setItem(this.sessionStorageKey, token);
      this.oAuthService.authorizationHeader = () => 'ultipro-interim ' + sessionStorage.getItem(this.sessionStorageKey);
      this.oAuthService.hasValidAccessToken = () => true;
      this.oAuthService.hasValidIdToken = () => true;
    }
  }
}
